import { createBrowserRouter } from "react-router-dom";

import ScrollToTop from "common/scroll-to-top";
import { protectedRoutes, publicRoutes } from "common/auth-routes";

import Page404 from "pages/page-404";
import PageFaq from "pages/faq/page-faq";
import PageCareer from "pages/career/page-career";
import PageClient from "pages/clients/page-client";
import PageEnquiry from "pages/enquiry/page-enquiry";
import PageClients from "pages/clients/page-clients";
import PageLogin from "pages/authenticate/page-login";
import PageArticle from "pages/articles/page-article";
import PageArticles from "pages/articles/page-articles";
import PagePartners from "pages/partners/page-partners";
import PageResources from "pages/resources/page-resources";
import PageSolutions from "pages/solutions/page-solutions";
import PageEBrochure from "pages/e-brochure/page-e-brochure";
import PagePopupAdsListing from "pages/popup-ads/page-popup-ads-listing";
import PagePopupAdsDetails from "pages/popup-ads/page-popup-ads-details";
import PageForgotPassword from "pages/authenticate/page-forgot-password";
import PageSolutionGroup from "pages/solution-group/page-solution-group";
import PageJobApplication from "pages/job-application/page-job-application";
import PageRecipientEmail from "pages/recipient-email/page-recipient-email";
import PageArticleCategory from "pages/articles-categories/page-article-category";
import PageOfficeLocationInfo from "pages/office-location/page-office-location-info";
import PageOfficeLocationListing from "pages/office-location/page-office-location-list";
import PageSolutionCategories from "pages/solution-categories/page-solution-categories";

import pathnames from "routes/pathnames";

import AppLayout from "components/app-layout";

export const routes = [
	{
		path: pathnames.default,
		element: <PageLogin />,
		authenticated: false,
		layout: false,
		roles: null,
	},
	{
		path: pathnames.forgotPassword,
		element: <PageForgotPassword />,
		authenticated: false,
		layout: false,
		roles: null,
	},
	{
		path: pathnames.articles,
		element: <PageArticles />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.article + ":id",
		element: <PageArticle />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.clients,
		element: <PageClients />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.client + ":id",
		element: <PageClient />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.faq,
		element: <PageFaq />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.resources,
		element: <PageResources />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.solutions,
		element: <PageSolutions />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.career,
		element: <PageCareer />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.eBrochure,
		element: <PageEBrochure />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.enquiry,
		element: <PageEnquiry />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.jobApplication,
		element: <PageJobApplication />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.popupAds,
		element: <PagePopupAdsListing />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.popupAdsDetails + ":id",
		element: <PagePopupAdsDetails />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.recipientEmail,
		element: <PageRecipientEmail />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.partners,
		element: <PagePartners />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.solutionGroup,
		element: <PageSolutionGroup />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.solutionCategories,
		element: <PageSolutionCategories />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.notFound,
		element: <Page404 />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.officeLocation,
		element: <PageOfficeLocationListing />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.officeLocationInfo + ":id",
		element: <PageOfficeLocationInfo />,
		authenticated: true,
		layout: true,
		roles: null,
	},
	{
		path: pathnames.articlesCategories,
		element: <PageArticleCategory />,
		authenticated: true,
		layout: true,
		roles: null,
	},
];

const enrichedRouters = routes.map(({ authenticated, ...res }) => {
	if (res.path === pathnames.forgotPassword) return {};

	if (!authenticated) return { ...res, loader: publicRoutes, errorElement: <Page404 /> };

	const element = res.layout ? (
		<ScrollToTop>
			<AppLayout>{res.element}</AppLayout>
		</ScrollToTop>
	) : (
		res.element
	);

	return {
		...res,
		element,
		loader: protectedRoutes,
		errorElement: (
			<AppLayout>
				<Page404 />
			</AppLayout>
		),
	};
});

const browserRouters = createBrowserRouter(enrichedRouters);

export default browserRouters;
